import { render, staticRenderFns } from "./ServiceManagementPanel.vue?vue&type=template&id=64483f06&scoped=true&"
import script from "./ServiceManagementPanel.vue?vue&type=script&lang=js&"
export * from "./ServiceManagementPanel.vue?vue&type=script&lang=js&"
import style0 from "./ServiceManagementPanel.vue?vue&type=style&index=0&id=64483f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64483f06",
  null
  
)

export default component.exports